// Affiliate "Comprar en Trezor" button — replaces the generic "Visitar sitio"
// CTA inside the comparador modal for Trezor products only.
import React from "react";
import { i18nTrezor, pickLang } from "../../i18n/trezor-affiliate";

// Direct affiliate links to each product page (aff_id=159881).
// Format documented by Trezor: https://trezor.io/{slug}?offer_id=1&aff_id=159881
const TREZOR_AFFILIATE_LINKS = {
  "trezor-model-one": "https://trezor.io/trezor-model-one?offer_id=1&aff_id=159881",
  "trezor-safe-3": "https://trezor.io/trezor-safe-3?offer_id=1&aff_id=159881",
  "trezor-model-t": "https://trezor.io/trezor-model-t?offer_id=1&aff_id=159881",
  "trezor-safe-5": "https://trezor.io/trezor-safe-5?offer_id=1&aff_id=159881",
};

const getTrezorLink = (walletId) =>
  TREZOR_AFFILIATE_LINKS[walletId] || "https://trezor.io/?aff_id=159881";

const TrezorComparadorBtn = ({ walletId, lang = "es" }) => {
  const L = ["es", "en", "sk", "de", "zh-CN"].includes(lang) ? lang : "en";
  if (!TREZOR_AFFILIATE_LINKS[walletId]) return null;
  return (
    <a
      href={getTrezorLink(walletId)}
      target="_blank"
      rel="noopener noreferrer sponsored"
      data-testid={`trezor-comparador-btn-${walletId}`}
      className="mt-5 inline-flex items-center gap-2 rounded-xl px-5 py-2.5 text-xs font-black uppercase tracking-widest text-black"
      style={{
        background: "linear-gradient(135deg, #00e676, #00c853)",
        boxShadow: "0 4px 18px rgba(0,230,118,0.35)",
      }}
    >
      {pickLang(i18nTrezor.comprarEn, L)}
    </a>
  );
};

export default TrezorComparadorBtn;
